// extracted by mini-css-extract-plugin
export default {"initial":"initial-Dd6fN","rowRemove":"rowRemove-kCm2M","disappearRow":"disappearRow-GqvcA","rowHidden":"rowHidden-sbMXE"};